const files = require.context('./modules', false, /\.js$/)
const modules = {}

files.keys().forEach(key => {
  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default
})

console.log(modules)

export default {
  namespaced: true,
  modules
}



// WEBPACK FOOTER //
// ./src/store/modules/userStore/index.js